export default __webpack_public_path__ + "static/media/control-5.c38f4361.svg";